import { render, staticRenderFns } from "./SecondaryTable.vue?vue&type=template&id=a8130a60"
import script from "./SecondaryTable.vue?vue&type=script&lang=js"
export * from "./SecondaryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports